export default __webpack_public_path__ + "static/media/036-fantasy.8d1feaff.svg";